import { Icon16InfoOutline } from '@vkontakte/icons';
import React, { useCallback, useRef, useState } from 'react';
import { IS_B2B_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { MAIL_HOST } from 'reactApp/modules/attaches/attaches.constants';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './AttachesTooltip.css';

export const AttachesTooltip = () => {
    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen((value) => !value);
    };

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    if (IS_B2B_BIZ_USER) {
        return null;
    }

    return (
        <>
            <div className={styles.info} onClick={handleClick} ref={ref}>
                Быстрый доступ к вложениям из писем
                <Icon16InfoOutline className={styles.infoIcon} />
            </div>
            {isOpen && (
                <FloatingTooltip target={ref} placement={ETooltipPlacement.bottomStart} onClose={handleClose} qaId="tooltip-attaches">
                    <div className={styles.tooltipRoot}>
                        <div className={styles.tooltipContent}>
                            Исходные файлы хранятся в Почте, удалить их <br /> можно только вместе с письмом через раздел <br /> для{' '}
                            <a className={styles.tooltipLink} target="_blank" href="/promo/quota/#cleaner" rel="noreferrer">
                                очистки хранилища
                            </a>{' '}
                            или в{' '}
                            <a className={styles.tooltipLink} target="_blank" href={`https://${MAIL_HOST}/inbox/`} rel="noreferrer">
                                Почте Mail.ru
                            </a>
                        </div>
                    </div>
                </FloatingTooltip>
            )}
        </>
    );
};
